import React from "react";

const chunkLoadPatterns = [
	/ChunkLoadError/i,
	/Loading chunk [\d]+ failed/i,
	/Loading CSS chunk [\d]+ failed/i,
	/Failed to fetch dynamically imported module/i,
	/Importing a module script failed/i,
];

function isChunkLoadError(error) {
	const message = `${error?.name || ""} ${error?.message || ""}`;
	return chunkLoadPatterns.some((pattern) => pattern.test(message));
}

export default class ChunkLoadErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null };
	}

	static getDerivedStateFromError(error) {
		return { error };
	}

	componentDidUpdate(prevProps) {
		if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
			this.setState({ error: null });
		}
	}

	render() {
		const { error } = this.state;
		if (!error) return this.props.children;

		const isChunkError = isChunkLoadError(error);
		const message = isChunkError
			? "頁面資源已更新或載入失敗，請重新整理後再試。"
			: "頁面載入時發生錯誤，請重新整理後再試。";

		return (
			<div
				role="alert"
				style={{
					minHeight: "240px",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					gap: "12px",
					padding: "24px",
					textAlign: "center",
					color: "#1f2933",
				}}
			>
				<div style={{ fontSize: "16px", fontWeight: 700 }}>{message}</div>
				<button
					type="button"
					onClick={() => window.location.reload()}
					style={{
						border: "1px solid #1f2933",
						background: "#fff",
						color: "#1f2933",
						padding: "8px 14px",
						cursor: "pointer",
					}}
				>
					重新整理
				</button>
			</div>
		);
	}
}
